import React from 'react';
import './Header.css'

const Header = () =>{
  return (
    <div className='header'>
      <h1 className='header__title'>Task.io</h1>
    </div>
  );
}

export default Header;